export enum EDITOR_ROUTE_PATH {
  widget = '/widget',
  settings = '/settings',
}

export enum DASHBOARD_PAGE_ROUTE_PATH {
  base = '',
  lobby = 'lobby-page',
  connect = 'connect-steps',
  create = 'create-ad',
  manage = 'manage-ads',
  edit = 'edit-ad',
}
